import {
  BucketKind,
  IEnumBucket,
  IRangeBucket,
  TimeUnit,
} from '../../../../utils/apollo/graphqlSchema';

import { IAutoRangeBucket } from './types';

export const durationPartitionTimeUnits = [
  TimeUnit.Second,
  TimeUnit.Minute,
  TimeUnit.Hour,
  TimeUnit.Day,
  TimeUnit.Week,
  TimeUnit.Month,
  TimeUnit.Year,
];

export const defaultAutoRangeBucket: IAutoRangeBucket = {
  min: null,
  max: null,
  binCount: null,
};

export const defaultEnumBucket: IEnumBucket = {
  __typename: 'EnumBucket',
  kind: BucketKind.Enum,
  name: '',
  values: [],
  isCustomName: false,
};

export const defaultRangeBucket: IRangeBucket = {
  __typename: 'RangeBucket',
  kind: BucketKind.Range,
  max: null,
  min: null,
  name: '',
  isCustomName: false,
};
